import type { SVGProps } from "react";
// generated from Heart.svg — do not edit manually
// prettier-ignore
export default function Heart(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 16.111 3 C 19.633 3 22 6.353 22 9.48 C 22 15.814 12.178 21 12 21 C 11.822 21 2 15.814 2 9.48 C 2 6.353 4.367 3 7.889 3 C 9.911 3 11.233 4.024 12 4.924 C 12.767 4.024 14.089 3 16.111 3 Z" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
